var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLight2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 585.143,
    viewBox: "0 0 512 585.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-light-2",
    d: "M365.714,146.286A109.714,109.714,0,1,0,256,256,109.714,109.714,0,0,0,365.714,146.286Zm-256,0A146.286,146.286,0,1,1,256,292.571,146.286,146.286,0,0,1,109.714,146.286ZM36.571,548.571H475.429C474.057,457.486,399.771,384,308.229,384H203.771C112.343,384,38.057,457.486,36.571,548.571ZM0,551.2C0,438.629,91.2,347.429,203.771,347.429H308.229C420.8,347.429,512,438.629,512,551.2a33.947,33.947,0,0,1-33.943,33.943H33.943A33.947,33.947,0,0,1,0,551.2Z",
    fill: "#c9c9c9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLight2);
export default __webpack_public_path__ + "static/media/user-light-2.112b747057de99bf99b335692437d3dd.svg";
export { ForwardRef as ReactComponent };